/**
 * Studio PR：`pageConfig` 中 `prPayloadPreset` 字面量映射为真实请求体构造，
 * 避免在配置文件中写超长函数字符串或 import `_utils`。
 */
import {
  buildPrStudioPayload,
  buildPrTrendPayload,
  buildPrEventTimelinePayload,
} from './_utils';

/** `PrStudioService` / Studio PR：`prPayloadPreset` 可选取值 */
export const PR_SERVICE_PAYLOAD_PRESET_MAP: Record<
  string,
  (data: Record<string, unknown>) => Record<string, unknown>
> = {
  'pr:studio': data => buildPrStudioPayload(data),
  'pr:trend': data => buildPrTrendPayload(data),
  'pr:eventTimeline': data => buildPrEventTimelinePayload(data),
};
